import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CONFIG } from '../config/app-config';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs'
@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  private dataSubject = new BehaviorSubject<any>(null);
  public data$ = this.dataSubject.asObservable();

  //pharmacy name to display in add medicine header
  sendData(data: any) {
    this.dataSubject.next(data);
  }

  constructor(private http: HttpClient) { }

  // getAllCategoryList(type,cat) {
  //   return this.http.get<any>(CONFIG.getAllCategoryListURL + '?type=' +
  // type+'&permission_slug=MEDICINES_INVENTORY_LIST&disease_category='+cat)
  //     .pipe(map(data => {
  //       return data;
  //     }));
  // }
  // getDiseaseCategoryList() {
  //   return this.http.get<any>(CONFIG.getAllCategoryListURL + '?type=0&permission_slug=MEDICINES_INVENTORY_LIST')
  //     .pipe(map(data => {
  //       return data;
  //     }));
  // }
  getMedicineDiseaseList (Diseasesdata: any) {
    return this.http.post<any>(CONFIG.getMedicineDiseaseListURL , Diseasesdata )
      .pipe(map(data => {
        return data;
      }));
  }
  getCategoryTreeview() {
    return this.http.get<any>(CONFIG.getCategoryTreeviewURL)
      .pipe(map(data => {
        return data;
      }));
  }

  getCategoryById (id: number) {
    return this.http.get<any>(CONFIG.getCategoryByIdURL + id)
      .pipe(map(data => {
        return data;
      }));
  }

  updateCategory (categoryData: any, id: number) {
    return this.http.post<any>(CONFIG.updateCategoryURL + id, categoryData)
      .pipe(map(response => {
        return response;
      }));
  }

  createCategory (categoryData: any) {
    return this.http.post<any>(CONFIG.createCategoryURL, categoryData)
      .pipe(map(response => {
        return response;
      }));

  }

  changeCategoryStatus (status: string, id: number, type , slug) {
    return this.http.put<any>( CONFIG.changeCategoryStatusURL + '?type=' + type, { id: id, status: status , permission_slug: slug })
      .pipe(map(response => {
        return response;
      }));
  }

  deleteCategory (id: number, type , slug) {
    return this.http.delete<any>(CONFIG.deleteCategoryURL + id + '?type=' + type + '&permission_slug=' + slug)
      .pipe(map(response => {
        return response;
      }));
  }

  saveCategoryTreeviewData(categoryData: any) {
    return this.http.post<any>(CONFIG.createCategoryTreeURL, categoryData)
      .pipe(map(response => {
        return response;
      }));
  }
  getParentCategoryList(catId: Number, parentName: String) {
    return this.http.get<any>(CONFIG.parentCategoryListURL + catId + '/' + parentName)
      .pipe(map(data => {
        return data;
      }));
  }
  getActiveCategoryList() {
    return this.http.get<any>(CONFIG.getActiveCategoryURL)
      .pipe(map(data => {
        return data;
      }));
  }
  getPharmaciesList(pharmData:any) {
    return this.http.post<any>(CONFIG.getPharmaciesList,pharmData)
      .pipe(map(data => {
        return data;
      }));
  }

  getInventoryList(data:any, id:number){
    return this.http.post<any>(CONFIG.getInventoryList + id,data)
      .pipe(map(data =>{
        return data;
      }));
  }

  addIndividualMedicine(data:any){
    return this.http.post<any>(CONFIG.addIndividualMedicine,data)
      .pipe(map(data=>{
        return data;
      }))
  }

  getMedicineById(id:any){
    return this.http.get<any>(CONFIG.getIndividualMedicineById+id)
      .pipe(map(data=>{
        return data;
      }))
  }

  updateIndividualMedicine(data:any){
    return this.http.post<any>(CONFIG.updateIndividualMedicine,data)
      .pipe(map(data=>{
        return data;
      }))
  }

  changeIndvMedicineStatus(id,status:any){
    return this.http.put<any>(CONFIG.changeStatusIndvMedicine+id, { status: status })
    .pipe(map(data=>{
      return data;
    }))
  }


  prescriptionStatusapi(id,is_priscription_require:any){
    return this.http.post<any>(CONFIG.changeStatusprescription+id, { is_priscription_require: is_priscription_require })
    .pipe(map(data=>{
      return data;
    }))
  }

  deleteIndvMedicine(id:any){
    return this.http.delete<any>(CONFIG.deleteIndvMedicine+id)
    .pipe(map(data=>{
      return data;
    }))
  }

   deleteProductImages(id:any){
    return this.http.delete<any>(CONFIG.deleteProductImagesURL+id)
    .pipe(map(data=>{
      return data;
    }))
  }

  importIndiviudalMedicine(data: any, uuid:any) {
  	return this.http.post<any>(CONFIG.importInventoryMedicine+uuid, data)
    .pipe(map(response => {
        return response;
    }));
  }
  
  exportIndiviudalMedicine(data: any, uuid:any) {
  	return this.http.post<any>(CONFIG.exportInventoryMedicine+uuid, data)
    .pipe(map(response => {
        return response;
    }));
  }

  getBatchViewList(uuid:any,data:any){
    return this.http.get<any>(CONFIG.getBatchViewList+uuid)
      .pipe(map(data => {
        return data;
    }));  
  }

  getitemwise(uuid:any,data:any){
    return this.http.get<any>(CONFIG.getitemwisepurchase+uuid)
      .pipe(map(data => {
        return data;
    }));  
  }

  AddEditIndividualMedicineBatch(data: any, uuid:any) {
  	return this.http.post<any>(CONFIG.addEditIndividualMedicineBatch+uuid, data)
    .pipe(map(response => {
        return response;
    }));
  }

  deleteBatch(id:any){
    return this.http.delete<any>(CONFIG.deleteBatch+id)
    .pipe(map(data=>{
      return data;
    }))
  }
  
}
